import React  from "react";
import { connect } from "react-redux";
import './css/gridSidePanel.css';
const SidePanelGrid = (props) => {
    return (
        <div
            className="drawer-panel"
            style={{
                top: 0,
                right: 0,
                width: 750,
                height: props.panelHeight,
                backgroundColor: 'white',
                boxShadow: '-2px 0 8px rgba(0,0,0,0.15)',
                zIndex: 10,
                padding: 20,
                overflowY: 'auto',
                transform: props.panelOpen ? 'translateX(0)' : 'translateX(100%)',
                opacity: props.panelOpen ? 1 : 0,
                transition: 'transform 0.3s ease, opacity 0.3s ease',
                pointerEvents: props.panelOpen ? 'auto' : 'none',
            }}
        >
            <button
                className="close-button"
                onClick={props.closePanel}
                style={{
                    fontSize: 30,
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    float: 'right',
                    marginBottom: 10,
                }}
                aria-label="Close panel"
            >
                ×
            </button>

            <div className="panel-content">
                {props.children}
            </div>
        </div>
    );
};


function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}

export default connect(mapStateToProps)(SidePanelGrid);
